{
  "header": {
    "nameShowStaticText": false,
    "nameStaticText": "",
    "nameVariable": {
      "id": "04c22f55-f9a0-4ad7-8f68-45cc20e8d9a2",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6001",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelStaticText": "",
    "modelVariable": {
      "id": "47dd2c2e-7e27-4352-87c5-367d545f3b5b",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6008",
      "displayName": "Model",
      "variablePath": "<GroupIdentifier>.Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "b15a1091-4010-4719-87d1-6594ce4aad80",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=6038",
      "displayName": "Number",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "modellingRule": "Mandatory",
      "hasProperties": true,
      "hasUnit": false,
      "hasRange": false
    },
    "colorValues": {
      "NotAvailable": "#ff0000",
      "OutOfService": "#804040",
      "Executing": "#00ff00",
      "Not Executing": "#ffff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "29aa5379-4527-4ce2-8118-832ec9fa37fc",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6002",
                "displayName": "Manufacturer",
                "variablePath": "<GroupIdentifier>.Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Instance URI",
              "showAsLink": false,
              "valueVariable": {
                "id": "b768b2f4-2f36-4701-baaa-3ea87d616b43",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6001",
                "displayName": "ProductInstanceUri",
                "variablePath": "<GroupIdentifier>.Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "80db1862-8e3f-41a3-9af6-1de6c6b82d77",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6008",
                "displayName": "Model",
                "variablePath": "<GroupIdentifier>.Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "showAsLink": false,
              "valueVariable": {
                "id": "f1fc1f5d-86cb-476f-b12b-23a37e1f35d0",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6009",
                "displayName": "Location",
                "variablePath": "<GroupIdentifier>.Identification.Location",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Production Output",
      "rows": [
        {
          "isPlaceholder": false,
          "title": "Current Weight",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Net Weight",
              "showAsLink": false,
              "valueVariable": {
                "id": "6a478d33-e78f-48aa-8f93-58069d8ef2ce",
                "modelUri": "http://opcfoundation.org/UA/Scales/V2/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Scales/V2/;i=60116",
                "displayName": "Net",
                "variablePath": "CurrentWeight.value.Net",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Gross Weight",
              "showAsLink": false,
              "valueVariable": {
                "id": "88a6d8c5-2906-4562-9d56-2d13261a4d82",
                "modelUri": "http://opcfoundation.org/UA/Scales/V2/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Scales/V2/;i=60117",
                "displayName": "Gross",
                "variablePath": "CurrentWeight.value.Gross",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Tare",
              "showAsLink": false,
              "valueVariable": {
                "id": "cb379178-b772-4eb5-9349-1c3701e5e8c9",
                "modelUri": "http://opcfoundation.org/UA/Scales/V2/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Scales/V2/;i=60118",
                "displayName": "Tare",
                "variablePath": "CurrentWeight.value.Tare",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "title": "Current PieceCounting",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Current Piece Count",
              "showAsLink": false,
              "valueVariable": {
                "id": "46756c01-8765-4b2b-8fac-46919c0a4d69",
                "modelUri": "http://opcfoundation.org/UA/Scales/V2/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Scales/V2/;i=607",
                "displayName": "CurrentPieceCount",
                "variablePath": "CurrentPieceCount",
                "dataType": "Number",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        },
        {
          "isPlaceholder": true,
          "title": "Product",
          "placeholderObject": "ProductionPreset.Products.<Product>.[PLACEHOLDER]",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Registered Piece Count",
              "showAsLink": false,
              "valueVariable": {
                "id": "fbd934cd-663a-4989-b12f-6ac84377be49",
                "modelUri": "http://opcfoundation.org/UA/Scales/V2/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Scales/V2/;i=607",
                "displayName": "RegisteredPieceCount",
                "variablePath": "RegisteredPieceCount",
                "dataType": "Number",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Totalized Item Count",
              "showAsLink": false,
              "valueVariable": {
                "id": "f37353ae-b422-440c-a5aa-302a2d847b4c",
                "modelUri": "http://opcfoundation.org/UA/Scales/V2/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Scales/V2/;i=607",
                "displayName": "TotalizedItemCount",
                "variablePath": "TotalizedItemCount",
                "dataType": "Number",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Reference Piece Weight",
              "showAsLink": false,
              "valueVariable": {
                "id": "1dbf3136-14ae-4b0c-a7db-71b83539c1e0",
                "modelUri": "http://opcfoundation.org/UA/Scales/V2/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Scales/V2/;i=607",
                "displayName": "ReferencePieceWeight",
                "variablePath": "ReferencePieceWeight",
                "dataType": "Number",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Machinery States",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 2,
              "label": "Machinery Item State",
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#000000",
                  "value": "NotAvailable",
                  "label": "Not Available"
                },
                {
                  "backgroundColor": "#804040",
                  "textColor": "#000000",
                  "value": "OutOfService",
                  "label": "Out Of Service"
                },
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#000000",
                  "value": "Executing",
                  "label": "Executing"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "Not Executing",
                  "label": "Not Executing"
                }
              ],
              "valueVariable": {
                "id": "897ce30a-1bbc-4051-9e76-f9809608f5cd",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6091",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            },
            {
              "type": 2,
              "label": "Machinery Operation Mode",
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#0000ff",
                  "textColor": "#000000",
                  "value": "None",
                  "label": "None"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#000000",
                  "value": "Maintenance",
                  "label": "Maintenance"
                },
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#000000",
                  "value": "Processing",
                  "label": "Processing"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#000000",
                  "value": "Setup",
                  "label": "Setup"
                }
              ],
              "valueVariable": {
                "id": "9a2943f2-f53a-4874-8b45-c8fdd9431686",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6092",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryOperationMode.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "titleVariable": {
            "id": "bfd2945e-e25b-427b-8e4c-48331fdf2cec",
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "ns=1;i=284",
            "displayName": "ApplicationTag",
            "variablePath": "ApplicationTag",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          },
          "placeholderObject": "Monitoring.Consumption.Electricity.[PLACEHOLDER]",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Voltage",
              "valueVariable": {
                "id": "d5e22b32-ebff-41f5-b2cf-a25fada54628",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6001",
                "displayName": "AcVoltagePe",
                "variablePath": "<MeasurementValue>.AcVoltagePe.value",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": true,
                "hasRange": false
              },
              "customUnit": "V"
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Current",
              "valueVariable": {
                "id": "c27b257b-1644-487c-871e-da72f045c5a9",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6002",
                "displayName": "AcCurrentPe",
                "variablePath": "<MeasurementValue>.AcCurrentPe.value",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": true,
                "hasRange": false
              },
              "customUnit": "A"
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Power",
              "valueVariable": {
                "id": "1123065d-0e40-4d64-98c6-e70de489eb92",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6003",
                "displayName": "AcActivePowerPe",
                "variablePath": "<MeasurementValue>.AcActivePowerPe.value",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": true,
                "hasRange": false
              },
              "customRangeHigh": 1000,
              "customRangeLow": 0,
              "customUnit": "W"
            }
          ]
        }
      ]
    }
  ]
}
